import { Accordion, AccordionDetails, AccordionSummary, LinearProgress, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import type { FC, PropsWithChildren } from "react";

interface Props {
  readonly title: string;
  readonly isLoading: boolean;
}

const DictionaryAccordion: FC<PropsWithChildren<Props>> = ({ children, title, isLoading }) => {
  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="h6">{title}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        {isLoading && <LinearProgress data-testid="loading-indicator" />}
        {children}
      </AccordionDetails>
    </Accordion>
  );
};

export default DictionaryAccordion;
